import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WorkflowService } from '../_services/workflow.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/core/reducers';
import { selectLatestCardValues } from 'src/app/core/events';
import { UpdateCardValues } from 'src/app/core/events/_actions/inbox.actions';

@Component({
  selector: 'kt-workflow-status-column',
  templateUrl: './workflow-status-column.component.html',
  styleUrls: ['./workflow-status-column.component.scss'],
})
export class WorkflowStatusColumnComponent implements OnInit, OnDestroy, OnChanges {
  listOfWorkflows = [];
  isLoading = true;
  @Input() filters: any = {};
  private workflowId: any;
  checkValues = null;
  private subscriptions: Subscription[] = [];
  @Input() filteredView;
  @Input() workflowGroupIdFromFilteredView;
  @Input() entitiesFromFilterView;
  @Output() totalCount = new EventEmitter<any>();
  @Input() status;
  size = 10;
  @Input() statusesList;
  indexOfList = 0;
  noMoreWorkflow = false;
  sort = 'created,desc';
  @Output() refreshWorkflowListAll = new EventEmitter<any>();

  constructor(
    public dialog: MatDialog,
    private workflowService: WorkflowService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private store: Store<AppState>,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.activatedRoute.params.subscribe((params) => {
        // load workflow in from campaign  or accordion list
        if (params.id) {
          this.workflowId = params.id;
          if (this.workflowId && !this.filteredView) {
            this.loadWorkflows();
          }
        }
      }),
    );
    this.subscriptions.push(
      this.store.pipe(select(selectLatestCardValues)).subscribe((res) => {
        if (res && res.workflow_queue_id !== null) {
          this.checkValues = {
            workflow_action_id: res.workflow_action_id,
            workflow_queue_id: res.workflow_queue_id,
          };
          this.store.dispatch(
            new UpdateCardValues({
              new_values: {
                group_id: null,
                workflow_queue_id: null,
                workflow_action_id: null,
              },
            }),
          );
        }
      }),
    );
  }

  ngOnChanges() {
    if (this.filteredView && this.workflowGroupIdFromFilteredView) {
      this.workflowId = this.workflowGroupIdFromFilteredView;
    }
    this.loadWorkflows();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  loadWorkflows() {
    if (!this.workflowId) return;
    this.isLoading = true;
    this.listOfWorkflows = [];
    if (this.filteredView && !this.entitiesFromFilterView) return;

    this.indexOfList = 0;
    this.noMoreWorkflow = false;
    const pageNumber = this.indexOfList;
    this.workflowService
      .getWorkflowsList(
        this.sort,
        pageNumber,
        this.size,
        this.status,
        this.workflowId,
        this.filters,
        this.filteredView,
        this.entitiesFromFilterView,
      )
      .subscribe((response) => {
        response?.data.forEach((workflow) => {
          if (!this.listOfWorkflows) {
            this.listOfWorkflows = [];
          }
          this.listOfWorkflows.push(workflow);
        });
        this.isLoading = false;
        this.cdr.detectChanges();
      });
  }

  onScroll(event) {
    if (this.noMoreWorkflow) return;
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight - 5) {
      setTimeout(() => this.loadMoreWorkflows(), 250);
    }
  }
  refreshWorkflowList(checkValues?) {
    this.checkValues = checkValues;
    this.refreshWorkflowListAll.emit();
    this.cdr.detectChanges();
  }

  loadMoreWorkflows() {
    const pageNumber = ++this.indexOfList;
    this.workflowService
      .getWorkflowsList(
        this.sort,
        pageNumber,
        this.size,
        this.status,
        this.workflowId,
        this.filters,
        this.filteredView,
        this.entitiesFromFilterView,
      )
      .subscribe((response) => {
        if (response?.data.length > 0) {
          this.listOfWorkflows = this.listOfWorkflows.concat(response.data);
          this.cdr.detectChanges();
          return;
        }
        this.noMoreWorkflow = true;
        this.cdr.detectChanges();
      });
  }
}
